import { TAG_CODES } from "../../tag.config"

const GOM_TRAFFIC_INDICATION = {
    type: 'path',
    tagCode: TAG_CODES.ROAD,
    withText: true,
    defaultText: 'Indication',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'default',
    withFillColor: true,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M 4 55 L 70 55 L 100 55 M 100 45 L 115 55 L 100 65 Z`,
}

export default GOM_TRAFFIC_INDICATION